// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-item {
  font-size: 13px;
  margin-right: 5px;
}

mat-card {
  direction: rtl;
  margin: 15px;
}

.text {
  font-size: 12px;
}

.buttons {
  margin-right: auto;
  margin-top: 20px;
}

.button-style {
  margin-right: 10px;
  font-size: 12px;
}

.text1 {
  color: rgb(103, 125, 143);
}

.text1.ng-star-inserted {
  width: 15rem;
  padding: 6px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  font-size: 13px;
  background-color: aliceblue;
  margin-top: 20px;
  text-align: center;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

h1 {
  font-size: 1.5rem;
}

.buttons {
  margin-top: 2rem;
}

button {
  width: 10rem;
  font-size: 12px;
  margin-right: 10px;
}

.text1 {
  color: rgb(103, 125, 143);
  width: 15rem;
  padding: 6px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  font-size: 13px;
  background-color: aliceblue;
  margin-top: 20px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/features/contracts/list-revision-contracts/list-revision-contracts.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/contracts/list-revision-contracts/list-revision-contracts.component.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,iBAAA;ACAJ;;ADEE;EACE,cAAA;EACA,YAAA;ACCJ;;ADEC;EACE,eAAA;ACCH;;ADEC;EACC,kBAAA;EACA,gBAAA;ACCF;;ADEC;EACC,kBAAA;EACC,eAAA;ACCH;;ADEC;EACC,yBAAA;ACCF;;ADEA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;ACCF;;ADCA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACEJ;;ADAE;EACE,eAAA;EACE,iBAAA;ACGN;;ADDE;EACE,iBAAA;ACIJ;;ADFE;EACE,gBAAA;ACKJ;;ADHE;EACE,YAAA;EACA,eAAA;EACA,kBAAA;ACMJ;;ADJE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;ACOJ","sourcesContent":["\r\n  .text-item{\r\n    font-size: 13px;\r\n    margin-right: 5px;\r\n  }\r\n  mat-card{\r\n    direction: rtl;\r\n    margin: 15px;\r\n  }\r\n\r\n .text{\r\n   font-size: 12px;\r\n }\r\n\r\n .buttons{\r\n  margin-right: auto;\r\n  margin-top: 20px;\r\n }\r\n\r\n .button-style{\r\n  margin-right: 10px;\r\n   font-size: 12px;\r\n }\r\n\r\n .text1{\r\n  color: rgb(103, 125, 143);\r\n }\r\n\r\n.text1.ng-star-inserted {\r\n  width: 15rem;\r\n  padding: 6px;\r\n  margin-left: 5px;\r\n  margin-right: 5px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  background-color: aliceblue;\r\n  margin-top: 20px;\r\n  text-align: center;\r\n}\r\n.title{\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  mat-icon{\r\n    font-size: 26px;\r\n      margin-left: 10px;\r\n  }\r\n  h1{\r\n    font-size: 1.5rem;\r\n  }\r\n  .buttons{\r\n    margin-top: 2rem;\r\n  }\r\n  button{\r\n    width: 10rem;\r\n    font-size: 12px;\r\n    margin-right: 10px;\r\n  }\r\n  .text1{\r\n    color: rgb(103, 125, 143);\r\n    width: 15rem;\r\n    padding: 6px;\r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n    border-radius: 10px;\r\n    font-size: 13px;\r\n    background-color: aliceblue;\r\n    margin-top: 20px;\r\n    text-align: center;\r\n   }",".text-item {\n  font-size: 13px;\n  margin-right: 5px;\n}\n\nmat-card {\n  direction: rtl;\n  margin: 15px;\n}\n\n.text {\n  font-size: 12px;\n}\n\n.buttons {\n  margin-right: auto;\n  margin-top: 20px;\n}\n\n.button-style {\n  margin-right: 10px;\n  font-size: 12px;\n}\n\n.text1 {\n  color: rgb(103, 125, 143);\n}\n\n.text1.ng-star-inserted {\n  width: 15rem;\n  padding: 6px;\n  margin-left: 5px;\n  margin-right: 5px;\n  border-radius: 10px;\n  font-size: 13px;\n  background-color: aliceblue;\n  margin-top: 20px;\n  text-align: center;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\n.buttons {\n  margin-top: 2rem;\n}\n\nbutton {\n  width: 10rem;\n  font-size: 12px;\n  margin-right: 10px;\n}\n\n.text1 {\n  color: rgb(103, 125, 143);\n  width: 15rem;\n  padding: 6px;\n  margin-left: 5px;\n  margin-right: 5px;\n  border-radius: 10px;\n  font-size: 13px;\n  background-color: aliceblue;\n  margin-top: 20px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
